import service from '../utils/request'
// 查询列表
export const query = params => {return service.post(`/api/base_section/query`, params)};
// 创建
export const create = params => {return service.post(`/api/base_section/create`, params)};
// 修改
export const edit = params => {return service.put(`/api/base_section/edit`, params)};
// 删除
export const deleted = params => {return service.delete(`/api/base_section/delete`, {params})};
// 获取桌台码
export const gettablecode = params => {return service.get(`/api/base_section/gettablecode`, {params})};
    